<template>
  <div>
    <vs-popup :active.sync="isOpen" title="Как произведено начисление" class="calculation-result-popup">
      <div class="vx-row">
        <div class="vx-col w-full mb-4">
          <h5 class="mb-4">Формула</h5>

          <div class="formula tariff-formula" style="display: inline">
            <span class="formula__item formula__unit">Значение тарифа</span>
            <span class="formula__item formula__operator">*</span>
            <span data-value="(" class="formula__item formula__bracket" style="display: inline">(</span>
            <div class="formula-text" style="display: inline"
                 v-html="formula">
            </div>
            <span data-value=")" class="formula__item formula__bracket">)</span>
          </div>
        </div>
        <div class="vx-col w-full mb-4">
          <h5 class="mb-4">Переменные</h5>

          <div class="formula__item formula__unit inline-block mb-1">Значение тарифа = <span class="font-medium">{{info.tariff_value}}</span></div>

          <div v-for="(constant, index) in constantsInFormula" :key="index">
            <div class="formula__item formula__unit inline-block mb-1">{{constant.name}} = <span class="font-medium">{{constant.value}}</span></div>
          </div>
        </div>
        <div class="vx-col w-full mb-4" v-if="info.branch_comment && info.branch_comment.length">
          <h5 class="mb-4">Комментарий</h5>

          <div>{{info.branch_comment}}</div>
        </div>
      </div>
    </vs-popup>
    <formula-popup :constants="constants" ref="formula" :formula="{}"/>
  </div>
</template>

<script>
  import FormulaPopup from "@/components/calculated-program/tariffs/FormulaPopup";

  export default {
    name: "CalculationResult",
    components: { FormulaPopup },
    props: {
      active: {
        type: Boolean,
        default: false,
      },
      info: {}
    },
    data: () => ({
      constants: {},
      formula: {},
      constantsInFormula: [],
    }),
    computed: {
      selectedHouseId(){
        return this.$store.getters['appUser/selectedHouse'].id;
      },
      isOpen: {
        get() {
          return this.active;
        },
        set(value) {
          this.$emit('update:active', value);
        }
      }
    },
    methods: {
      setFormula(){
          this.formula = this.$refs.formula ? this.$refs.formula.getHtml(this.info.formula, false) : "";
      },
      setFormulaConstants(){
        this.constantsInFormula = [];

        this.info.constants.forEach(item => {
          let constant = this.constants.find(constant => constant.code === item.code);
          let name = "Не известная переменная";

          if(constant){
            name = constant.name;
          }

          this.constantsInFormula.push({
            name: name,
            value: item.value
          })

        });
      },
      async getConstants() {
        return new Promise(async (resolve, reject) => {
          try {
            let {data} = await this.$http.get('constants', {
              params: {
                buildings_id: this.selectedHouseId
              }
            });

            this.constants = data;

            resolve();
          } catch (e) {
            this.constants = [];
            reject();
          }
        })
      },
    },
    mounted() {
      this.getConstants();
    },
    watch: {
      isOpen(val){
        if(val){
          this.setFormula();
          this.setFormulaConstants();
        }
      }
    }
  }
</script>

<style lang="scss">
  .formula {
    &__item {
      display: inline;
      vertical-align: middle;
      word-break: break-all;
      background-color: #f2f2f2;
      border-radius: 999px;
      position: relative;
      overflow: hidden;
      font-size: .9rem;
      white-space: nowrap;
      border: 1px solid rgba(0,0,0,.2);
      line-height: 1.5;
      padding: 4px 10px;
      margin: 3px;
      color: #333333;
    }

    &__operator {
      color: #f6474e;
      background-color: transparent;
      border: none;
      margin-left: 0;
      margin-right: 0;
      padding: 0;
      padding-left: 3px;
      padding-right: 3px;
      font-size: 1.25rem;
    }

    &__bracket {
      background-color: transparent;
      border: none;
      color: #12c2b7;
      margin-left: 0;
      margin-right: 0;
      padding: 0;
      padding-left: 1px;
      padding-right: 1px;
      font-size: 1.5rem;
    }

    &-text{
      white-space: normal;
      word-break: break-all;
    }
  }

  .calculation-result-popup{
    .vs-popup{
      width: 850px;
    }
  }
</style>